import { fetchConToken } from "../helpers/fetch";

const AvisoPrestacionService = {
  validarDatosParaTurno: (data) => {
    return fetchConToken(`AvisoDePrestacion/ValidarDatosParaTurnoPrestadorExterno`, data, "POST");
  },
  enviarNotificacion:(idRegistroAtencion, data)=>{
    return fetchConToken(`AvisoDePrestacion/EnviarNotificacion/${idRegistroAtencion}`, data, "POST");
  },
  verificarCodigo:(idRegistroAtencion, data)=>{
    return fetchConToken(`AvisoDePrestacion/ValidarCodigoDeVerificacion/${idRegistroAtencion}`, data, "POST");
  },
  getData:(idRegistroAtencion)=>{
    return fetchConToken(`AvisoDePrestacion/${idRegistroAtencion}`, {}, "GET");
  }
};

export { AvisoPrestacionService as default };
